/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Showing a quote always needs a reason and \[confirmedWithCarrier\], whatever its purpose and including quotes too old to have one --- a price reaches a customer only once someone has checked it with the carrier. A Benchmark quote is refused whatever is sent.
 * @export
 * @interface ShowQuoteBody
 */
export interface ShowQuoteBody {
  /**
   *
   * @type {string}
   * @memberof ShowQuoteBody
   */
  reason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShowQuoteBody
   */
  confirmedWithCarrier: boolean;
}

/**
 * Check if a given object implements the ShowQuoteBody interface.
 */
export function instanceOfShowQuoteBody(value: object): value is ShowQuoteBody {
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  return true;
}

export function ShowQuoteBodyFromJSON(json: any): ShowQuoteBody {
  return ShowQuoteBodyFromJSONTyped(json, false);
}

export function ShowQuoteBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShowQuoteBody {
  if (json == null) {
    return json;
  }
  return {
    reason: json["reason"] == null ? undefined : json["reason"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
  };
}

export function ShowQuoteBodyToJSON(json: any): ShowQuoteBody {
  return ShowQuoteBodyToJSONTyped(json, false);
}

export function ShowQuoteBodyToJSONTyped(
  value?: ShowQuoteBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    reason: value["reason"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
  };
}
